import { render, staticRenderFns } from "./new_contacto.vue?vue&type=template&id=1bffe8de&scoped=true"
import script from "./new_contacto.vue?vue&type=script&lang=js"
export * from "./new_contacto.vue?vue&type=script&lang=js"
import style0 from "./new_contacto.vue?vue&type=style&index=0&id=1bffe8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffe8de",
  null
  
)

export default component.exports